import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { isValidElement, useCallback, useMemo, Children, memo, } from 'react';
import { InternalTab } from './Tab';
const topStyles = css `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .tab-list {
    border-bottom: 1px solid #ccc;
    padding-left: 0;
    margin: 0;
    display: inline-flex;
  }

  .tab-list li:first-of-type {
    margin-left: 5px;
  }

  .tab-list li:hover {
    background-color: #f7f7f7;
  }

  .tab-list-item {
    display: inline-flex;
    list-style: none;
    padding: 0.5rem 2rem;
  }

  .tab-list-active {
    background-color: white;
    border: solid #ccc;
    border-width: 1px 1px 0 1px;
  }

  .tab-content {
    height: 100%;
    overflow: auto;
  }
`;
const leftStyles = css `
  display: flex;
  height: 100%;
  width: 100%;
  .tab-list {
    border-right: 1px solid #ccc;
    padding-left: 0;
    margin: 0;
  }

  .tab-list li:hover {
    background-color: #f7f7f7;
  }

  .tab-list li:first-of-type {
    margin-top: 10px;
  }

  .tab-list-item {
    display: block;
    list-style: none;
    margin-right: -1px;
    padding: 0.5rem 0.75rem;
  }

  .tab-list-active {
    background-color: white;
    border: solid #ccc;
    border-width: 1px 0px 1px 1px;
  }

  .tab-content {
    height: 100%;
    overflow: auto;
  }
`;
export var PositionsEnum;
(function (PositionsEnum) {
    PositionsEnum["TOP"] = "TOP";
    PositionsEnum["LEFT"] = "LEFT";
})(PositionsEnum || (PositionsEnum = {}));
function Tabs({ children, onClick, position, onDelete = () => null, activeTab, }) {
    const onClickTabHandler = useCallback((tab) => {
        const { tablabel, tabid } = tab;
        onClick({ tablabel, tabid });
    }, [onClick]);
    let contentChild;
    const tabs = Children.map(children, (child) => {
        if (!isValidElement(child))
            return null;
        const { tabid } = child.props;
        if (tabid === activeTab) {
            contentChild = child.props.children;
        }
        return (_jsx(InternalTab, { ...child.props, isActive: tabid === activeTab, onClick: onClickTabHandler, onDelete: onDelete }));
    });
    const styles = useMemo(() => {
        switch (position) {
            case PositionsEnum.TOP:
                return topStyles;
            case PositionsEnum.LEFT:
                return leftStyles;
            default:
                return topStyles;
        }
    }, [position]);
    return (_jsxs("div", { className: "tabs", css: styles, children: [_jsx("ol", { className: "tab-list", children: tabs }), _jsx("div", { className: "tab-content", children: contentChild })] }));
}
export default memo(Tabs);
